// @flow
import React from 'react';
import styled, {css} from 'styled-components';
import Button from './BaseButton';
import {DefaultTheme} from 'trustar-2.0/themes';
import type {ThemeType} from 'trustar-2.0/types';
import {Icon, IconLookup, Spinner} from 'trustar-2.0/components';
import {getButtonColorWithTheme, inDarkMode} from '../../themes/common';

const ColorStyle = ({buttonType = 'primary', theme, noHover}) => {
  const color = getButtonColorWithTheme(buttonType, theme);

  const textColor = !inDarkMode(theme) && buttonType === 'light' ? theme.ThemeColors.BLACK: color;
  return`
      color: ${textColor.hex};
      padding: 3px;
      
      ${!noHover ? `
        &:hover {
          color: ${textColor.hover()};
          text-shadow: 0 0 ${inDarkMode ? '1.5px' : '1px'} ${textColor.hover()};
        }` : ''}
  `;
};

const WithSeperatorStyle = ({theme}) => `
  :after {
    margin-left: 0.5rem;
    color: ${theme.ThemeColors.TEXT.hex};
    content: '|';
`;


const StyledTextButton = styled(Button)`
  ${ColorStyle}
  ${({withSeperator}) => withSeperator ? WithSeperatorStyle : ''}
`;


type TextButtonPropType = {
  children?: any,
  theme?: ThemeType,
  iconToTheRight?: boolean,
  withSeperator?: boolean,
};

const TextButton = ({icon, ...props}: TextButtonPropType) => {

  return (
    <StyledTextButton
      transparent
      strictStyle={false}
      padButton={props.children} {...props}>
      {props.children}
    </StyledTextButton>
  );
};
export default TextButton;



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Button/TextButton.js